export class LoginForm {
    public email: string;
    public password: string;

    constructor() {}
}
